import type { SxProps, Theme } from "@mui/material";

/** Figma 9128:96387 / 9131:97591 — 600px white elevated review dialog */
export const requestDialogPaperSx: SxProps<Theme> = {
  width: "100%",
  maxWidth: 600,
  minWidth: { xs: 0, sm: 600 },
  m: 2,
  borderRadius: "4px",
  bgcolor: "#fff",
  boxShadow: "0px 8px 16px rgba(0,0,0,0.14), 0px 0px 2px rgba(0,0,0,0.12)",
  overflow: "hidden",
  maxHeight: "calc(100vh - 32px)",
  display: "flex",
  flexDirection: "column",
};

export const requestDialogShellSx: SxProps<Theme> = {
  display: "flex",
  flexDirection: "column",
  gap: 2,
  pt: 1.5,
  minWidth: 0,
  maxHeight: "calc(100vh - 32px)",
  flex: 1,
};

export const requestDialogHeaderSx: SxProps<Theme> = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  pl: 3,
  pr: "22px",
  flexShrink: 0,
};

export const requestDialogBodySx: SxProps<Theme> = {
  flex: 1,
  minHeight: 0,
  overflowY: "auto",
  display: "flex",
  flexDirection: "column",
  gap: 2,
  px: 3,
  py: 2.5,
  borderTop: "1px solid #e5e5e5",
  borderBottom: "1px solid #e5e5e5",
};

export const requestDialogFooterSx: SxProps<Theme> = {
  flexShrink: 0,
  display: "flex",
  justifyContent: "flex-end",
  gap: 1,
  flexWrap: "wrap",
  px: 3,
  pt: 1,
  pb: 3,
};
